export default ({ theme }) => `
display: flex;
flex-direction: column;
align-items: flex-start;
width: 100%;

  .features-container {
    justify-content: flex-start;
    width: 100%;
    padding: 10px 0;
    /* border-top: 1px solid ${theme.borderColor}; */

    display: grid;
    grid-template-columns: 1fr; /* Single column layout */
    /* gap: 10px; */

    @media (min-width: 500px) { /* Two-column layout when width > 500px */
      grid-template-columns: 1fr 1fr;
    }

    .feature {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      padding: 5px 0;
    }

    .material-icons.available{
      color:${theme.accentColor};
      font-size: 24px;
      padding: 0px 5px;
    }

    .material-icons.not-available{
      color:${theme.borderColor };
      font-size: 24px;
      padding: 0px 5px;
    }

    .material-icons {
      padding: 0px 5px;
    }
    
    .feature-text {
      font-size: 14px;
      font-weight: bold;
      color: #495c63;
      margin-right: 10px;
      display: flex;
      align-items: center;
    }

  }

  p {
    font-size: 20px;
  }

 }
`;